export default __webpack_public_path__ + "static/media/bg1.919015de.png";